module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"statusPending":"En attente","statusStarted":"En cours","statusEnded":"Terminé"},"en":{"statusPending":"Pending","statusStarted":"In progress","statusEnded":"Ended"}}')
  delete Component.options._Ctor
}
